import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container service__container">
        <article className='service'>
          <div className="service__head">
            <h3>Content Creation</h3>
          </div>
          
          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Content writing: A professional content writing service can help you create high-quality content for your website.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Graphic design: A graphic designer can help create images, infographics, and graphics for your website.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Photography and videography: If you need photos or videos for your website, a professional photographer or videographer can help you create high-quality visual content.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Search engine optimization (SEO): An SEO expert can help optimize your content for search engines.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Content marketing: A content marketing specialist can help you create a content marketing strategy for your website.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Editing and proofreading: An editing and proofreading service can help improve the quality of your content.</p>
            </li> 
          </ul>
        </article>
        {/**/}
        <article className='service'>
          <div className="service__head">
            <h3>Salesforce Development</h3>
          </div>
          
          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Custom Salesforce Development: Custom Salesforce development involves building custom applications and functionality on the Salesforce platform.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Salesforce Integration: Salesforce integration involves connecting Salesforce with other business systems and applications.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Salesforce Lightning Development: Salesforce Lightning is a modern user interface framework that allows developers to build dynamic, responsive user interfaces on the Salesforce platform.</p>
            </li><li>
              <BiCheck className='service__list-icon' />
              <p>Salesforce Community Development: Salesforce Community development involves building custom communities for customers, partners, or employees on the Salesforce platform.</p>
            </li><li>
              <BiCheck className='service__list-icon' />
              <p>Salesforce Migration and Upgrades: Salesforce migration and upgrade services involve migrating data and functionality from legacy systems to Salesforce or upgrading existing Salesforce implementations to the latest version.</p>
            </li><li>
              <BiCheck className='service__list-icon' />
              <p>Salesforce Consulting and Strategy: Salesforce consulting and strategy services involve working with businesses to develop a Salesforce roadmap and strategy.</p>
            </li> 
          </ul>
        </article>
        {/* WEB DEVELOPMENT */}
        <article className='service'>
          <div className="service__head">
            <h3>Web Development</h3>
          </div>
          
          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon' />
              <p> Front-end Development: Front-end development involves creating the user interface and user experience for a website.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Back-end Development: Back-end development involves creating the server-side of a website.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Full-Stack Development: Full-stack development combines both front-end and back-end development.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p> E-commerce Development: E-commerce development involves creating online stores that allow customers to purchase products or services online.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Content Management System (CMS) Development: CMS development involves creating a system that allows website owners to manage their content easily.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon' />
              <p>Mobile App Development: Mobile app development involves creating applications that run on mobile devices like smartphones and tablets.</p>
            </li> 
            <li>
              <BiCheck className='service__list-icon' />
              <p> Web Hosting and Maintenance: Web hosting and maintenance services involve managing the server infrastructure and ensuring the website is up and running 24/7.</p>
            </li>
          </ul>
        </article>
        {/* END OF CONTENT CREATION */}
      </div>
    </section>
  )
}

export default Services